import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Contact from "./Pages/Home/Contact/Contact";
import AboutMe from "./Pages/Home/AboutMe/AboutMe";
import Blogs from "./Pages/Home/Blogs/Blogs";
import Error from "./Pages/Error/Error";
import PrrojectsContainer from "./Pages/Home/PrrojectsContainer/PrrojectsContainer";
import Details from "./Pages/Details/Details";
function App() {
  return (
    <div className="app">
      <Router>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route exact path="/home">
            <Home></Home>
          </Route>
          <Route path="/aboutMe">
            <AboutMe></AboutMe>
          </Route>
          <Route path="/blogs">
            <Blogs></Blogs>
          </Route>
          <Route path="/projects">
            <PrrojectsContainer></PrrojectsContainer>
          </Route>
          <Route path="/project/:projectId">
            <Details></Details>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
          <Route exact path="/error">
            <Error></Error>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
